import { useMutation } from "@tanstack/react-query";

import {
  ILiberarRemessasLotePayload,
  ILiberarRemessasLoteResponse,
  ILiberarRemessasLoteValidacaoResponse,
} from "@/hooks/liberar-remessa/index.d";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleLiberarRemessasEmLote } from "@/domain/use-cases/liberar-remessa";
import { notifyError } from "@/utils/notify-messages";

export function useLiberarRemessasLoteBalcao() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    ILiberarRemessasLoteResponse | ILiberarRemessasLoteValidacaoResponse,
    Error,
    ILiberarRemessasLotePayload
  >({
    mutationFn: async (payload) => {
      return (await handleLiberarRemessasEmLote(token!, payload)) as
        | ILiberarRemessasLoteResponse
        | ILiberarRemessasLoteValidacaoResponse;
    },
    onError: () => {
      notifyError("Houve um problema ao tentar liberar as remessas em lote!");
    },
  });

  return {
    liberarRemessasEmLote: mutation.mutate,
    liberarRemessasEmLoteAsync: mutation.mutateAsync,
    isLoadingLiberarRemessasEmLote: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
